import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import Modal from 'flarum/common/components/Modal';
import m from 'mithril';

class SamePosterModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loadingPosts = true;
    this.posts = [];

    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/thread-structure/same-poster/' + this.attrs.postId,
      })
      .then((data) => {
        this.posts = (data && data.posts) || [];
        this.loadingPosts = false;
        m.redraw();
      })
      .catch(() => {
        this.loadingPosts = false;
        m.redraw();
      });
  }

  className() {
    return 'SamePosterModal Modal--small';
  }

  title() {
    return 'ID:' + this.attrs.hash + ' の投稿一覧';
  }

  content() {
    if (this.loadingPosts) {
      return m('.Modal-body', m('p', '読み込み中…'));
    }

    if (!this.posts.length) {
      return m('.Modal-body', m('p', '見つかりませんでした'));
    }

    return m(
      '.Modal-body',
      m(
        'ul',
        { className: 'SamePosterModal-list' },
        this.posts.map((p) =>
          m(
            'li',
            m(
              'a',
              {
                href: '#',
                onclick: (e) => {
                  e.preventDefault();
                  this.hide();
                  m.route.set('/d/' + this.attrs.discussionSlug + '/' + p.number);
                },
              },
              m('span', { className: 'SamePosterModal-number' }, p.number + '. '),
              p.excerpt || '(本文なし)'
            )
          )
        )
      )
    );
  }
}

app.initializers.add('local-thread-structure', () => {
  // "1. " / "2. " post-number label, shown next to the poster's name.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    const number = post && post.number ? post.number() : null;

    if (number) {
      // High priority so this renders first, before the username item.
      items.add('thread-structure-number', m('span', { className: 'ThreadStructure-number' }, `${number}. `), 1000);
    }

    const hash = post && post.attribute ? post.attribute('posterHash') : null;
    const count = post && post.attribute ? post.attribute('posterPostCountInThread') : null;

    if (hash) {
      items.add(
        'thread-structure-id',
        m(
          'a',
          {
            href: '#',
            className: 'ThreadStructure-id',
            onclick: (e) => {
              e.preventDefault();
              app.modal.show(SamePosterModal, {
                hash,
                postId: post.id(),
                discussionSlug: post.discussion().slug(),
              });
            },
          },
          `ID:${hash}`,
          count ? m('span', { className: 'ThreadStructure-idCount' }, ` (${count})`) : null
        ),
        // Core's username item uses priority 100 and its "meta" (timestamp)
        // item uses the default (0) -- 50 puts this right after the name,
        // before the timestamp.
        50
      );
    }
  });

  // Rewrite the native "@username" quote-reply label to ">>N" (the parent
  // post's number), once that post's number is available client-side.
  extend(CommentPost.prototype, 'oncreate', function () {
    rewriteQuoteLabels(this.element);
  });

  extend(CommentPost.prototype, 'onupdate', function () {
    rewriteQuoteLabels(this.element);
  });
});

function rewriteQuoteLabels(element) {
  if (!element || !element.querySelectorAll) return;

  const mentions = element.querySelectorAll('.Post-body .PostMention');

  mentions.forEach((anchor) => {
    if (anchor.dataset.threadStructureRewritten === '1') return;

    const postId = anchor.getAttribute('data-id');
    if (!postId) return;

    const referenced = app.store.getById('posts', postId);
    const number = referenced && referenced.number ? referenced.number() : null;

    // If the referenced post isn't loaded client-side yet, leave the
    // original "@username" label as a graceful fallback.
    if (number) {
      anchor.textContent = `>>${number}`;
      anchor.dataset.threadStructureRewritten = '1';
    }
  });
}
